<template>
    <div class="accno-input-ui">
        <el-input v-if="disabled" :value="`${gccno}${suffix ? ` - ${suffix}` : ''}`" disabled style="width: 110px;"></el-input>
        <div v-else class="wrapper">
            <el-input
                v-model.trim="gccno"
                ref="gccno"
                class="gccno-input"
                maxlength="4"
                :disabled="disabled"
                @blur="$emit('blur')"
                @input="onGccnoInput"
                @paste.native.capture="onPaste"
            ></el-input>
            <span
                ref="dash"
                class="dash"
                :class="{ shown: isShowDash }"
            > - </span>
            <el-input
                v-model.trim="suffix"
                ref="suffix"
                class="suffix-input"
                maxlength="4"
                :disabled="disabled"
                @blur="$emit('blur')"
                @paste.native.capture="onPaste"
                @keydown.native.backspace="onSuffixBackspace"
            ></el-input>
        </div>
    </div>
</template>

<script>
export default {
    mixins: [],
    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: Boolean,
    },
    components: {},
    data() {
        return {
            isPaste: false,
        };
    },
    computed: {
        gccno: {
            set(val) {
                const typeValidate = this.onCheckType('gccno', val);
                if (!typeValidate) return;

                if (this.suffix) this.$emit('input', `${val}-${this.suffix}`);
                else this.$emit('input', `${val}`);
            },
            get() {
                return this.value.split('-')[0] || '';
            },
        },
        suffix: {
            set(val) {
                const typeValidate = this.onCheckType('suffix', val);
                if (!typeValidate) return;

                if (val) this.$emit('input', `${this.gccno}-${val}`);
                else this.$emit('input', `${this.gccno}`);
            },
            get() {
                return this.value.split('-')[1];
            },
        },
        isShowDash() {
            return !!this.suffix;
        },
    },
    methods: {
        onPaste() {
            this.isPaste = true;
            setTimeout(() => {
                this.isPaste = false;
            }, 10);
        },
        onGccnoInput(val) {
            // 檢查輸入值的長度是否等於 maxlength
            const maxLength = 4;
            if (val && val.length === maxLength) {
                this.$nextTick(() => {
                    const suffixInput = this.$refs.suffix;
                    if (suffixInput) {
                        // 讓第二個 input focus
                        suffixInput.focus();
                        // 透過取得原生 input DOM，並設定游標位置在最前面
                        suffixInput.$el.children[0].setSelectionRange(0, 0);
                    }
                });
            }
        },
        onSuffixBackspace(event) {
            // 檢查 suffix 的 v-model (this.suffix) 是否為空
            if (!this.suffix) {
                // 阻止 Backspace 的預設行為 (例如頁面後退)
                event.preventDefault();

                const gccnoInput = this.$refs.gccno;
                if (gccnoInput) {
                    // 將焦點移回第一個輸入框
                    gccnoInput.focus();

                    // 使用 $nextTick 確保 focus 完成後再設定游標位置
                    this.$nextTick(() => {
                        const textLength = this.gccno.length;
                        // 將游標設定在文字的最後
                        gccnoInput.$el.children[0].setSelectionRange(textLength, textLength);
                    });
                }
            }
        },
        onCheckType(target, val) {
            if (val === '') return true;

            const inputNumberFormat = Number(val);
            const isNumber = !Number.isNaN(inputNumberFormat);
            if (isNumber) return true;

            this.shake(this.$refs[target].$el);
            return false;
        },
        shake(target) {
            if (this.isPaste) return;

            target.classList.add('shake');
            target.classList.add('shake-constant');
            setTimeout(() => {
                target.classList.remove('shake');
                target.classList.remove('shake-constant');
            }, 150);
        },
    },
};
</script>

<style lang="scss" >
.accno-input-ui {
    .wrapper {
        display: inline-flex;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        align-items: center;
        height: 40px;

        .el-input input {
            border: 0;
            padding: 0 0px;
            height: 30px;
            line-height: 30px;
        }

        .gccno-input input {
            width: 50px;
            padding-left: 15px;
        }
        .suffix-input input {
            width: 55px;
            padding-left: 4px;
        }

        &:focus-within {
            border-width: 2px;
            border-color: #463cb2;
        }

        .dash {
            color: #ccc;

            &.shown {
                color: #000;
            }
        }
    }
}

.el-form-item.is-error {
    .accno-input-ui > .wrapper {
        border-color: #F56C6C;
    }
}
</style>
